import md5 from 'md5';
import {sm4} from 'sm-crypto';

export const privateKey = '877348D3C3A140BD99063C1B6D9A5E3D';

/**
 * 读取本地的 txt/json 文件
 * @param {string} name     文件路径
 * @returns 
 */
export const loadFile = function(name){
    //name为文件所在位置
    let xhr = new XMLHttpRequest()
    const requestStatus = document.location.protocol === 'file:' ? 0 : 200
    xhr.open('GET', name, false)
    xhr.overrideMimeType('text/html;chartset=utf-8')    //默认为utf-8编码
    xhr.send(null)
    return xhr.status === requestStatus ? xhr.responseText : null
}

/**
 * 请求地址相关配置
 */
let receiveData = JSON.parse(loadFile('fstsign_.json'))
export let ajaxUrl = receiveData.casLogin.ajaxUrl
export let apiUrl = "";
export let isopenwclogin = receiveData.weChatRedirectUrl.isOpenWeChatLogin;
//避免fstsign_.json写api链接时后漏写“/”字符
if (ajaxUrl[ajaxUrl.length - 1] == "/") {
    apiUrl = ajaxUrl + "api/";
} else {
    apiUrl = ajaxUrl + "/api/";
}

/**
 * 获取地图ak
 */
export let mapakval = receiveData.Map.Ak;
// hcg 2025-11-20 add
export let maptkval = receiveData.Map.Tk;

/**
 * 判断是否为Json字符串
 * @param {*} o     需判断的任意类型对象
 * @returns {boolean}   返回布尔值
 */
export function isJsonStr(o) {
    try {
        return typeof JSON.parse(o) == "object";
    } catch (e) {
        return false;
    }
}

/**
 * MD5签名方法
 * @param {object} data     签名对象 
 * @returns {string}    返回所有参数值相加转encodeURIComponent再MD5加密后的值
 */
export function MD5_Sign(data) {
    let sign = "";
    for (let item in data) {
        let val = data[item];
        if (item == "sign") {
            continue;
        }
        if (val !== undefined && val !== null) {
            sign += (typeof val == "object" ? JSON.stringify(data[item]) : String(data[item]));
        }
    }
    //转换编码再加密，防止有汉字MD5加密，前后端不一致。
    var _b_sign = encodeURIComponent(sign).toUpperCase();
    return md5(_b_sign);
}

/**
 * sm4加密
 * @param {String} ciphertext   加密内容
 * @param {String} key          密钥
 */
export function SM4_Encrypt(ciphertext, key) {
    const decrypted = sm4.encrypt(ciphertext, key)
    return decrypted
}

/**
 * sm4解密
 * @param {String} ciphertext   密文内容
 * @param {String} key          密钥
 */
export function SM4_Decrypt(ciphertext, key) {
    const decrypted = sm4.decrypt(ciphertext, key)
    return decrypted
}


/**
 * 获取地址栏的参数,未找到时返回null
 * @param {string} name     需要获取的参数名
 * @param {window} win      获取的参数所有的window对象 不传默认取当前窗口的
 * @param {boolean} isDecode    是否解码，默认true
 * @returns {string}    解析出来的地址参数值
 */
export function QueryString(name, win, isDecode) {
    isDecode = isDecode === false ? false : true;
    if (!win) {
        win = window;
    }
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var n = win.location.search.substring(1).match(reg);
    if (n != null) {
        if (isDecode) {
            return decodeURIComponent(n[2]);
        } else {
            return n[2];
        }
    }
    return null;
}

/**
 * 获取登录证书
 * @returns {string}    登陆证书值
 */
export function getLoginData() {
    var ukey = "F.K.SEC.S_ID"; //key固定不变
    return $.cookie(ukey);
}

/**
 * 获取cookie值，提取自 jquery.cookie.js 文件
 * @param {string} name     cookie的键
 * @param {string} value    cookie的值
 * @param {object} options  其他选项
 * @returns 
 */
export function getCookie(name, value, options) {
    if (typeof value != 'undefined') { // name and value given, set cookie
        options = options || {};
        if (value === null) {
            value = '';
            options.expires = -1;
        }
        var expires = '';
        if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
            var date;
            if (typeof options.expires == 'number') {
                date = new Date();
                date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
            } else {
                date = options.expires;
            }
            expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
        }
        var path = options.path ? '; path=' + options.path : '';
        var domain = options.domain ? '; domain=' + options.domain : '';
        var secure = options.secure ? '; secure' : '';
        document.cookie = [name, '=', encodeURIComponent(value), expires, path, domain, secure].join('');
    } else { // only name given, get cookie
        var cookieValue = null;
        if (document.cookie && document.cookie != '') {
            var cookies = document.cookie.split(';');
            for (var i = 0; i < cookies.length; i++) {
                var cookie = jQuery.trim(cookies[i]);
                // Does this cookie string begin with the name we want?
                if (cookie.substring(0, name.length + 1) == (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    }
};


